import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-launch-challenge',
  standalone:false,
  templateUrl: './launch-challenge.component.html'
})
export class LaunchChallengeComponent {
 RFPForm: FormGroup;
  uploadedFiles: File[] = [];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  @Input() schemeType: string;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  
  isEditorDisabled: boolean = false;
commentForm: FormGroup;
  userID: any;
   payload: {
    // proposal_id: any;
    proposal_name: any;
  };


  constructor(private fb: FormBuilder, private config: PrimeNGConfig, 
    private messageService: MessageService,
    private uploadService: UploadService,
     private api: ApiService, private route: ActivatedRoute) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
     this.commentForm = this.fb.group({
      start_date: [''],
      challenge_status: [''],
      end_date: [''],
    });
   }

  ngOnInit(): void {
    console.log("stepDetails", this.stepDetails);
    this.RFPForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.getRfpDetails()
     this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        
        proposal_name: proposalName,
      };
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if ( this.stepDetails?.can_edit) {
        this.commentForm.enable();
      } else {
        this.commentForm.disable();
      }
    }, 300);
  }


  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
    expandedSections: { [key: string]: boolean } = {
    challengeForm: false,
    basicInfo: true,
    problemStatement: false,
    detailedInfo: false,
    additionalInfo: false,
    uploads: false,
    
  };

  
  rfpdata: any;
  challengesData: any;
  getRfpDetails() {
    this.api.getAPI(`/idex/launch/challenge/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
      this.rfpdata = res.launch_data[0];
      this.challengesData = res.challenge;
      this.commentForm.patchValue({
        start_date: this.rfpdata?.start_date,
        end_date: this.rfpdata?.end_date,
        challenge_status: this.challengesData?.challenge_status,
      });
    });
    
  }



  onSubmit(): void {
    
    const formData = {
      start_date: this.commentForm.get('start_date').value,
      end_date: this.commentForm.get('end_date').value,
      challenge_status: this.commentForm.get('challenge_status').value,
      challenge_id: this.challengesData.id,
    };

    if (this.rfpdata) {
    this.api.putAPI(`/idex/launch/challenge/${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
      
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Record updated successfully' });
      });

    } else {
  this.api.postAPI('/idex/launch/challenge/', formData).subscribe((res: any) => {
        this.getRfpDetails();
      
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Record updated successfully' });
      });
    }
    
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "SSCT", value: this.RFPForm.get('comment')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 30) + '...' : fileName;
  }

}
